import { TypePolicies } from '@apollo/client/core';

export default {
  CurrentUserModel: {
    fields: {
      fullName: {
        read(_, { readField }) {
          return [readField('first_name'), readField('last_name')].filter(v => v).join(' ');
        },
      },
    },
  },
} satisfies TypePolicies;
